import React, { useEffect, useRef, useState } from "react";
import { Box, Typography, Card, CardContent, Button } from "@mui/material";
import OfficeImg from "../../Assets/office.jpg";
import TopNavBar from "../../Custom/TopNavBar";
import "../../css/mobilecss.css";
import Footer from "../FooterSection";
import TeamList from "../TeamList/TeamList";
import FloatingNavBar from "../../Custom/FloatingNavBar";
import http from "../../../../../httpService";
import { useParams } from "react-router-dom";
import { animated, useScroll, useSpring } from "@react-spring/web";
import FloatNavBarMobile from "../../Custom/FloatNavBarMobile";

const PortfolioMobileView = () => {
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [showFloatingNav, setShowFloatingNav] = useState(false);
  const [loading, setLoading] = useState(true);
  const { uuid } = useParams();
  const [checkDepartment, setCheckDepartment] = useState(0);   const [categoryList, setCategoryList] = useState([]);
  const [teamMembers, setTeamMembers] = useState([]);
  const containerRef = React.useRef(null);
  const [isProduct, setIsProduct] = useState(true);
  // const [deviceHeight, setDeviceHeight] = useState(667); // default
  // const [deviceWidth, setDeviceWidth] = useState(window.innerWidth); // Store the device width
  const [offsetPosition, setOffsetPosition] = useState(0);
  const boxRef1 = useRef(null);
  const boxRef2 = useRef(null);
  // const [boxWidth, setBoxWidth] = useState(0);
  const boxWidthRef = useRef(null);
  const [distance, setDistance] = useState(0);
  const triggerRef = useRef(null);

  // Function to calculate the distance
  const calculateDistance = () => {
    if (boxRef1.current && boxRef2.current) {
      const rect1 = boxRef1.current.getBoundingClientRect();
      const rect2 = boxRef2.current.getBoundingClientRect();

      // Calculate the distance using Euclidean distance formula
      const dx = rect2.left - rect1.left;
      const dy = rect2.top - rect1.top;
      const distance = Math.sqrt(dx * dx + dy * dy);

      setDistance(distance);
    }
  };

  useEffect(() => {
    calculateDistance(); // Calculate the distance on mount and when the component updates
  }, []);

  // useEffect(() => {
  //   return () => {
  //     console.log("Distance between the two boxes:", distance); // Log the distance when the component unmounts
  //   };
  // }, [distance]);

  const { scrollYProgress } = useScroll({
    container: containerRef,
    onChange: ({ value }) => {
      calculateDistance(); // Calculate the distance when scroll position changes
      // console.log("Scroll Progress:", value.scrollYProgress); // Log scroll progress
    },
  });

  // useEffect(() => {
  //   // Function to find the X-coordinate of the text element
  //   const findXPosition = () => {
  //     if (boxWidthRef.current) {
  //       const rect = boxWidthRef.current.getBoundingClientRect();
  //       setBoxWidth(rect.left); // Or rect.x
  //     }
  //   };

  //   findXPosition(); // Call the function on mount

  //   // Optionally, re-calculate on resize
  //   window.addEventListener("resize", findXPosition);

  //   return () => {
  //     window.removeEventListener("resize", findXPosition); // Cleanup on unmount
  //   };
  // }, []);

  // useEffect(() => {
  //   // Get the actual height of the device/window
  //   const handleResize = () => {
  //     setDeviceHeight(window.innerHeight);
  //   };

  //   handleResize(); // Run once on mount
  //   window.addEventListener("resize", handleResize);

  //   return () => window.removeEventListener("resize", handleResize);
  // }, []);

  // Adjust the width when the window resizes
  // useEffect(() => {
  //   const handleResize = () => {
  //     setDeviceWidth(window.innerWidth); // Update device width on resize
  //   };

  //   window.addEventListener("resize", handleResize); // Add resize event listener
  //   return () => window.removeEventListener("resize", handleResize); // Clean up on unmount
  // }, []);

  const calculateOffsetPositionBasedOnWidth = (viewportWidth) => {
    // Example logic: You can replace this with any calculation you need
    if (viewportWidth <= 320) {
      return 15; // For small devices (e.g., mobile)
    } else if (viewportWidth <= 375) {
      return 5; // For medium devices (e.g., tablets)
    } else if (viewportWidth <= 390) {
      return -2; // For medium devices (e.g., tablets)
    } else if (viewportWidth <= 425) {
      return -15; // For medium devices (e.g., tablets)
    } else if (viewportWidth <= 430) {
      return -18; // For medium devices (e.g., tablets)
    } else if (viewportWidth <= 450) {
      return -22; // For medium devices (e.g., tablets)
    } else if (viewportWidth <= 480) {
      return -40; // For medium devices (e.g., tablets)
    } else if (viewportWidth <= 520) {
      return -53; // For medium devices (e.g., tablets)
    } else if (viewportWidth <= 550) {
      return -80; // For medium devices (e.g., tablets)
    } else {
      return -35; // For large devices (e.g., desktop)
    }
  };

  useEffect(() => {
    // Calculate initial offset position based on window width
    const initialOffsetPosition = calculateOffsetPositionBasedOnWidth(
      window.innerWidth
    );
    setOffsetPosition(initialOffsetPosition);

    // Resize handler to update offset position dynamically
    const handleResize = () => {
      const newOffsetPosition = calculateOffsetPositionBasedOnWidth(
        window.innerWidth
      );
      setOffsetPosition(newOffsetPosition);
    };

    // Add resize event listener
    window.addEventListener("resize", handleResize);

    // Cleanup the event listener on component unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && checkDepartment === 1) {
          setShowFloatingNav(true); // Show navbar when the section is in view and department_wise is 1
        } else {
          setShowFloatingNav(false); // Hide navbar if not in view
        }
      },
      {
        root: null, // viewport
        threshold: 0.6, // 60% of the element should be visible before it triggers
      }
    );

    if (triggerRef.current) {
      observer.observe(triggerRef.current); // Start observing the trigger element
    }

    return () => {
      if (triggerRef.current) {
        observer.unobserve(triggerRef.current); // Cleanup the observer
      }
    };
  }, [checkDepartment]);
  // Fetch team members from the API
  useEffect(() => {
    const fetchTeamMembers = async () => {
      try {
        const response = await http.get("/api/portfolio/" + uuid, {
          headers: {
            Accept: "application/json",
            "ngrok-skip-browser-warning": "true",
          },
        });
        sessionStorage.setItem("portolioId", uuid);

        if (response.data.success && response.data.data) {
          const apiData = response.data.data;

          let employees = [];
          let categories = [];
          setCheckDepartment(apiData?.department_wise); // Update checkDepartment based on response

          Object.keys(apiData).forEach((key) => {
            const members = apiData[key];
            if (Array.isArray(members)) {
              categories.push(key);
              const enrichedMembers = members.map((member) => ({
                ...member,
                category: key,
              }));
              employees = [...employees, ...enrichedMembers];
            }
          });

          // console.log(employees); // All employees with their respective category

          setCategoryList(["All", ...categories]);
          setTeamMembers(employees);
        } else {
          setTeamMembers([]); // If no valid data, set to empty array
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setTeamMembers([]); // Handle error scenario
      } finally {
        setLoading(false);
      }
    };

    fetchTeamMembers();
  }, []);

  // Linked Scroll Animation using React Spring
  const fadeAnimation = useSpring({
    opacity: scrollYProgress.to([0, 0.03], [1, 0]), // Fade out as you scroll
    config: { duration: 500 },
  });

  // Calculate the animation offsets based on the distance
  const moveDownAnimation = useSpring({
    transform: scrollYProgress.to(
      [0, 0.029, 0.039, 0.049, 0.058, 0.087, 0.12],
      [
        `translateY(0px) translateX(0px) scale(1)`,
        `translateY(${distance - 500}px) translateX(0px) scale(1)`,
        `translateY(${distance - 350}px) translateX(0px) scale(1)`,
        `translateY(${distance - 250}px) translateX(0px) scale(1)`,
        `translateY(${distance - 150}px) translateX(0px) scale(1)`,
        `translateY(${
          distance - 40
        }px) translateX(${offsetPosition}px) scale(1)`,
        `translateY(${
          distance - 40
        }px) translateX(${offsetPosition}px) scale(1)`,
      ]
    ),
    config: { tension: 80, friction: 15 }, // smoother and slower
  });

  const weAreTextAnimation = useSpring({
    opacity: scrollYProgress.to([0.17, 0.18], [0, 1]), // Fade in as you scroll
    transform: scrollYProgress.to(
      [0.17, 0.18, 0],
      [
        "translateY(0px) translateX(-100px)",
        "translateY(0px) translateX(0px)",
        "translateY(0px) translateX(0px)",
      ]
    ),
    config: { duration: 10 },
  });

  const productFadeAnimation = useSpring({
    opacity: 1,
    from: { opacity: 0 },
    reset: true,
    config: { duration: 100 },
    // Trigger on value change
    key: isProduct ? "Product" : "Services",
  });
  useEffect(() => {
    const interval = setInterval(() => {
      setIsProduct((prev) => !prev);
    }, 2000);
    return () => clearInterval(interval);
  }, []);

  const aProductAnimation = useSpring({
    opacity: scrollYProgress.to([0.19, 0.2], [0, 1]), // Fade in as you scroll further
    transform: scrollYProgress.to(
      [0.19, 0.2, 0],
      [
        "translateY(0px) translateX(-200px)",
        "translateY(0px) translateX(0px) ",
        "translateY(0px) translateX(0px)",
      ]
    ),
    config: { duration: 5 },
  });

  const ProviderAnimation = useSpring({
    opacity: scrollYProgress.to([0.195, 0.25], [0, 1]), // Fade in as you scroll further
    transform: scrollYProgress.to(
      [0.195, 0.25, 0],
      [
        "translateY(0px) translateX(-100px)",
        "translateY(0px) translateX(0px) ",
        "translateY(0px) translateX(0px)",
      ]
    ),
    config: { duration: 5 },
  });

  return (
    <Box
      sx={{
        position: "relative",
        minHeight: "100vh", // Minimum height to cover the entire viewport
        backgroundImage: `linear-gradient(to top, rgba(0, 0, 0, .97)12%, rgba(0, 0, 0, 0.25) 35%), 
             linear-gradient(to bottom, rgba(0, 0, 0, 1) 5%, rgba(0, 0, 0, 0.25) 35%), 
             url(${OfficeImg})`,
        backgroundSize: "280% 620px", // Fix the height of the background image and make it responsive
        backgroundPosition: "center",
        backgroundRepeat: "repeat-y", // Repeat background on the Y-axis if content exceeds height
        width: "100%", // Full width
        overflow: "auto", // Allow scrolling if needed
        animation: "backgroundMove 10s infinite linear", // Apply background animation
      }}
    >
      {showFloatingNav && checkDepartment === 1 && (
        <FloatNavBarMobile
          categoryList={categoryList}
          selectedCategory={selectedCategory}
          setSelectedCategory={setSelectedCategory}
        />
      )}
      {/* Gradient Overlay */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          background:
            "linear-gradient(to bottom right, rgba(0,0,0,0.16), rgba(0,0,0,0.15))",
          zIndex: 1,
        }}
      />
      <TopNavBar />
      <Box
        sx={{
          position: "relative",
          backgroundColor: "rgba(126, 126, 126, 0.3)",
          borderRadius: "24px",
          minHeight: "100vh",
          width: "94%",
          margin: "8px auto",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          backdropFilter: "blur(3px)",
          border: "1px solid rgba(234, 234, 234, 0.2)",
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.5)",
          padding: 2,
          overflowY: "auto",
          zIndex: 1,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
            mt: { xs: 1, sm: 2 },
            gap: 4,
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              height: "100vh",
              width: "100%",
              px: { xs: 1, sm: 5 }, // horizontal padding for spacing
            }}
          >
            {/* Top Section */}
            <Box sx={{ mt: { xs: 30, sm: 34 }, mb: { xs: 20, sm: 24 } }}>
              <animated.div style={fadeAnimation}>
                <Typography
                  ref={boxRef1}
                  sx={{
                    fontFamily: "Poppins, sans-serif",
                    color: "#EBEBEB",
                    fontSize: { xs: "1.7rem", sm: "1.9rem" },
                    fontWeight: 300,
                    textAlign: "start",
                  }}
                >
                  Welcome!
                </Typography>
              </animated.div>
              <animated.div style={moveDownAnimation}>
                <Typography
                  sx={{
                    fontFamily: "Poppins, sans-serif",
                    color: "#FFFFFF",
                    fontSize: { xs: "3rem", sm: "3.9rem" },
                    fontWeight: 600,
                    lineHeight: 1,
                    textAlign: "center",
                  }}
                >
                  Clockhash
                </Typography>
              </animated.div>
              <animated.div style={fadeAnimation}>
                <Typography
                  sx={{
                    fontFamily: "Poppins, sans-serif",
                    fontWeight: 500,
                    color: "#EBEBEB",
                    fontSize: { xs: "1.7rem", sm: "1.9rem" },
                    textAlign: "end",
                  }}
                >
                  Technologies
                </Typography>
              </animated.div>
            </Box>

            {/* Bottom Section */}
            <animated.div style={fadeAnimation}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  width: "100%",
                  mb: { xs: 8, sm: 10 },
                }}
              >
                <Typography
                  sx={{
                    textAlign: "center",
                    fontFamily: "Poppins, sans-serif",
                    color: "#EBEBEB",
                    fontWeight: 400,
                    fontSize: { xs: ".85rem", sm: ".95rem" },
                  }}
                >
                  Bringing bold ideas to life through
                </Typography>
                <Typography
                  sx={{
                    textAlign: "center",
                    fontFamily: "Prata, sans-serif",
                    color: "#EBEBEB",
                    fontWeight: 400,
                    letterSpacing: 1,
                    fontSize: { xs: ".75rem", sm: ".85rem" },
                  }}
                >
                  design and tech
                </Typography>
              </Box>
            </animated.div>
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "auto",
              width: "100%",
              px: { xs: 2, sm: 4, md: 8 },
            }}
          >
            <Box
              ref={boxWidthRef}
              sx={{
                display: "flex",
                flexDirection: "column",
                textAlign: "start",
                width: "100%",
                ml: { xs: 2, sm: 4 },
                maxWidth: "800px",
              }}
            >
              <animated.div style={weAreTextAnimation}>
                <Typography
                  sx={{
                    // background: "yellow",
                    fontFamily: "Poppins, sans-serif",
                    color: "#FFFFFF",
                    fontSize: "2.9rem",
                    fontWeight: 500,
                    lineHeight: 1.2,
                    mb: 1,
                  }}
                >
                  We're
                </Typography>
              </animated.div>

              <Box ref={boxRef2} sx={{ height: "5vh" }}></Box>
              <animated.div style={aProductAnimation}>
                <Typography
                  sx={{
                    fontFamily: "Prata, sans-serif",
                    fontSize: { xs: "3.1rem", sm: "3.3rem" },
                    fontWeight: 500,
                    display: "flex",
                    lineHeight: 1.3,
                    alignItems: "center",
                    gap: 1,
                    color: "#FFFFFF",
                    flexWrap: "wrap",
                    mt: 2,
                  }}
                >
                  <span style={{ color: "#FFFFFF" }}>a</span>
                  <animated.span
                    style={{ color: "#000000", ...productFadeAnimation }}
                  >
                    {isProduct ? "Product" : "Services"}
                  </animated.span>{" "}
                </Typography>
              </animated.div>
              <animated.div style={ProviderAnimation}>
                <Typography
                  sx={{
                    fontFamily: "Poppins, sans-serif",
                    color: "#FFFFFF",
                    fontSize: { xs: "2.9rem", sm: "3.3rem" },
                    lineHeight: 1.2,
                    fontWeight: 500,
                  }}
                >
                  Provider
                </Typography>
              </animated.div>
            </Box>
          </Box>

          <Box>
            <Typography
              ref={triggerRef}
              sx={{
                color: "#FFFFFF",
                mt: 6,
                fontSize: "2.5rem",
                fontFamily: "Poppins, sans-serif",
                fontWeight: 600,
              }}
            >
              Meet the Team
            </Typography>
          </Box>
          <TeamList
            selectedCategory={selectedCategory}
            teamMembers={teamMembers}
            loading={loading}
          />
          <Box
            sx={{
              height: "100%",
              width: "96%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              zIndex: 2,
              mt: 9,
              overflow: "auto",
            }}
          ></Box>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "left",
              alignItems: "start",
              textAlign: "start",
              zIndex: 2,
              pl: 1,
              mt: 15,
              mb: 10,
              color: "white",
            }}
          >
            <Box sx={{ marginBottom: 3 }}>
              <Typography
                sx={{
                  fontSize: "1rem",
                  fontFamily: "Poppins, sans-serif",
                  fontWeight: "100",
                }}
              >
                Make an
              </Typography>
              <Typography
                sx={{
                  fontSize: "4rem",
                  fontWeight: "700",
                  fontFamily: "Poppins, sans-serif",
                  lineHeight: 1,
                }}
              >
                Impact
              </Typography>
              <Typography
                sx={{
                  fontSize: "1rem",
                  textAlign: "end",
                  fontFamily: "Poppins, sans-serif",
                  fontWeight: "100",
                }}
              >
                With us!
              </Typography>
            </Box>
            <Box sx={{ width: "40%" }}>
              <Typography
                sx={{
                  fontSize: ".7rem",
                  fontFamily: "Poppins, sans-serif",
                  fontWeight: "400",
                  lineHeight: 1.2,
                  marginBottom: 2,
                }}
              >
                Trial Period as a part of Hiring process
              </Typography>
              <Typography
                sx={{
                  fontSize: ".7rem",
                  fontWeight: "100",
                  fontFamily: "Poppins, sans-serif",
                  lineHeight: 1.2,
                }}
              >
                We offer 3 days trial for clients to prove our candidates are a
                good match
              </Typography>
              <Button
                sx={{
                  borderRadius: "12px",
                  backgroundColor: "rgba(71, 71, 71, 0.2)",
                  backdropFilter: "blur(20px)",
                  color: "white",
                  marginTop: 2,
                  paddingX: 0.5,
                  whiteSpace: "nowrap",
                  fontFamily: "Poppins, sans-serif",
                  fontSize: ".8rem",
                  fontWeight: "300",
                  textTransform: "inherit", // Capitalize the text
                  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.5)", // Added shadow
                  border: "1px solid rgba(34, 34, 34, 0.3)", // Optional border
                  transition: "all 0.3s ease", // Smooth transition for hover effect
                  "&:hover": {
                    color: "black",
                    boxShadow: "0px 6px 15px rgba(0, 0, 0, 0.7)", // Stronger shadow on hover
                    backgroundColor: "rgba(179, 177, 177, 0.4)", // Slightly darker background on hover
                  },
                }}
                onClick={() =>
                  window.open(
                    "https://calendly.com/marketing-clockhash/introduction-call",
                    "_blank"
                  )
                }
              >
                Book an Appointment
              </Button>
            </Box>
          </Box>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Footer />
          </Box>
          <Box sx={{ zIndex: 2, mb: 0.5 }}>
            <Typography sx={{ color: "white", fontSize: ".6rem" }}>
              @ Copyright 2025 Clockhash.All Rights Reserved
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default PortfolioMobileView;
